module.exports = "/images/ny-life1-12.jpg";